import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {TreatmentFracturesModel} from '../../models/treatment-fractures.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TreatmentEndoDataModel} from '../../models/treatment-endo-data.model';
import {TreatmentService} from '../../../../services/treatment.service';
import {TreatmentEndoFractureDataModel} from '../../models/treatment-endo-fracture-data.model';
import {Globals} from '../../../../globals';
import {TdoTableRowModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MatSelectChange} from '@angular/material/select';

@Component({
  selector: 'app-treatment-fractures-dialog',
  templateUrl: './treatment-fractures-dialog.component.html',
  styleUrls: ['./treatment-fractures-dialog.component.scss']
})
export class TreatmentFracturesDialogComponent implements OnInit {
  @ViewChild('tdoTable') tdoTable: TdoTableV2Component;

  isLoading = true;

  fractures: TreatmentFracturesModel[] = [];

  locationDropdownData: TdoDropdownModel[] = [];
  typeDropdownData: TdoDropdownModel[] = [];
  extensionDropdownData: TdoDropdownModel[] = [];
  transIlluminationDropdownData: TdoDropdownModel[] = [];

  locationEnumItems: EnumValidValueItemModel[];
  typeEnumItems: EnumValidValueItemModel[];
  extensionEnumItems: EnumValidValueItemModel[];
  transIlluminationEnumItems: EnumValidValueItemModel[];
  CaseWorkItemToothId: string;
  toothNum: string;

  //treatmentModel: TreatmentEndoDataModel;

  constructor(private dialogRef: MatDialogRef<TreatmentFracturesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private treatmentService: TreatmentService,
              private globals: Globals,
              private staticDataService: StaticDataService) {
    //this.treatmentModel = data;
  }

  ngOnInit(): void {
    this.CaseWorkItemToothId = this.data.CaseWorkItemToothId;
    this.toothNum = this.data.toothNum;
    this.locationDropdownData = this.createEnumDropdownModels('enumEndoFractureLocation');
    this.typeDropdownData = this.createEnumDropdownModels('enumEndoFractureType');
    this.extensionDropdownData = this.createEnumDropdownModels('enumEndoFractureExtension');
    this.transIlluminationDropdownData = this.createEnumDropdownModels('enumEndoFractureTransillumination');

    this.locationEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureLocation');
    this.typeEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureType');
    this.extensionEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureExtension');
    this.transIlluminationEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumEndoFractureTransillumination');

    this.treatmentService.getFractures(this.CaseWorkItemToothId).subscribe((res) => {
      this.fractures = res;
      this.isLoading = false;
    });
  }

  onAddFractureClick() {
    // Dummy data
    const model = new TreatmentFracturesModel();
    model.CaseWorkItemToothId = this.CaseWorkItemToothId;
    model.PatientId = this.globals.currentPatientId;
    this.treatmentService.saveFracture(model).subscribe((res) => {
      this.fractures.push(res);
      this.tdoTable.updateData();
    });
  }

  onOkClick() {
    this.dialogRef.close(this.fractures);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onShowAllChange(event: MatCheckboxChange) {

  }

  getLocationDropdownValue(location: Location) {
    if (this.locationDropdownData && this.locationDropdownData.length > 0) {
      const model = this.locationDropdownData.find(p => p.value.ValidValueItemId === location).value;
      if (model) {
        return model;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  private createEnumDropdownModels(enumName: string): TdoDropdownModel[] {
    const enums = this.staticDataService.getValidValueItemsByValidValueName(enumName);
    const ddModels: TdoDropdownModel[] = [];
    if (enums) {
      for (const vvi of enums) {
        ddModels.push(new TdoDropdownModel(vvi.ItemDisplayValue, vvi));
      }
    }
    return ddModels;
  }

  getToothNum(row: TdoTableRowModel) {
    return this.toothNum;
  }

  onTdoDropdownChange(event: MatSelectChange, row: TdoTableRowModel, enumID: string) {
    row.model[enumID] = event.value.ValidValueItemId;
    this.treatmentService.saveFracture(row.model).subscribe((res) => {
      row.model = res;
    });
  }

  getValueByEnumId(locationEnumItems: EnumValidValueItemModel[], enumEndoFractureLocationID: string) {
    return locationEnumItems.find(p => p.ValidValueItemId === enumEndoFractureLocationID);
  }
}
